"use server"

import { sdk } from "@lib/config"
import { getAuthHeaders } from "./cookies"

/**
 * Translatable facet entry: stable canonical (en) value for URL/filter contract,
 * plus a locale-specific label for display.
 */
export type LabeledFacetEntry = { value: string; label: string; count: number }

export type FilterFacets = {
  type_counts?: Record<string, number>
  content_language?: Record<string, number>
  language_independent_count?: number
  in_stock_count?: number
  // Game facets
  age_rating?: Record<string, number>
  complexity?: Record<string, number>
  player_counts?: Record<string, number>
  play_time?: Record<string, number>
  game_type?: LabeledFacetEntry[]
  theme?: LabeledFacetEntry[]
  // Book facets
  binding_type?: Record<string, number>
  age_recommendation?: Record<string, number>
  genre?: LabeledFacetEntry[]
  // Collections (id → count); cross-filtered by everything except collection itself
  collections?: Record<string, number>
}

export type FilterResult = {
  product_ids: string[]
  facets: FilterFacets
}

/**
 * Fetch product IDs matching game/book attribute filters.
 * Also returns facets (available filter values with counts).
 */
export async function getFilteredProductIds(
  params: Record<string, string>
): Promise<FilterResult> {
  const headers = await getAuthHeaders()

  try {
    const result = await sdk.client.fetch<FilterResult>(
      `/store/products/filter`,
      {
        method: "GET",
        query: params,
        headers,
        next: { revalidate: 300 },
      }
    )
    return result
  } catch (error) {
    console.error("[Filter] Error fetching filtered products:", error)
    return { product_ids: [], facets: {} }
  }
}
